// extracted by mini-css-extract-plugin
export var clickThrough = "_z5-2";
export var fallback = "_z5-5";
export var frame = "_z5-3";
export var frameCell = "_z5-1";
export var overlay = "_z5-4";
export var wrapper = "_z5-0";